import React, { useState } from "react";
import PaymentSettings from "./paymentSettings";
import ChecklistManagement from "./checklistManagement";

const tabs = ['Payment Settings', 'Checklist Settings'];

export default function ConfigurationSettings() {
  const [activeTab, setActiveTab] = useState("Payment Settings");

  const renderContent = () => {
      switch (activeTab) {
        case 'Payment Settings':
          return <PaymentSettings />;
        case 'Checklist Settings':
          return <ChecklistManagement  />;
        default:
          return null;
      }
    };

  return (


       <div className="pl-8 pr-6">
      <h2 className="text-2xl font-semibold mb-2 mt-1 ml-1">Configuration Settings</h2>

      <div className='bg-[var(--primary-bg-color)] rounded-lg shadow px-2 pt-5 dark:border dark:border-[var(--table-border)]'>
        {/* Tab Header */}
        <div className="flex border-b mb-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 border-b-2 text-sm font-medium transition-all ${activeTab === tab
                  ? 'border-[#3587B8] text-[#3587B8]'
                  : 'border-transparent text-gray-500 hover:text-[#3587B8]'
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="py-6">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}
